import axios, { AxiosResponse } from "axios";
import type { BekraftaStaKvarPayload, VerifieraKodPayload } from "./index";

export const verifieraPinkod = async (payload: VerifieraKodPayload) : Promise<AxiosResponse> => {
//	console.log("verifieraPinkod request som skickas till backend --> " + JSON.stringify(payload, null));
	return await axios.post(encodeURI("/api/verifieraPinkod"), payload);
}

export const bekraftaStaKvar = async (payload: BekraftaStaKvarPayload) : Promise<AxiosResponse> => {
//	console.log("bekraftaStaKvar request som skickas till backend --> " + JSON.stringify(payload, null));
	return await axios.post(encodeURI("/api/bekraftaStaKvar"), payload);
};

export const aktuellMiljo = async () : Promise<AxiosResponse> => {
	return await axios.get(encodeURI("/api/aktuellMiljo"));
}
